module.exports = __webpack_public_path__ + "media/images/but-close-31b6a9ef.png";